<template>
<v-container fill-height fluid>
  <v-layout>
    <v-flex>
      <v-card>
        <v-toolbar card color="primary" dark>
          <v-toolbar-title>
            Cobranças
          </v-toolbar-title>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="items"
          :pagination.sync="pagination"
          :rows-per-page-items="pages"
          :loading="loading"
          :total-items="total"
          class="elevation-1"
          disable-initial-sort
        >
        <template v-slot:items="props">
          <td v-bind:class="{'red--text':props.item.status == 'OVERDUE'}">
            {{ $t(`payments.status.${props.item.status}`) }}
          </td>
          <td>
            {{props.item.description}}
          </td>
          <td>{{ props.item.dateCreated | date }}</td>
          <td>R$ {{ props.item.value | money }}</td>
          <td>{{ props.item.dueDate | date }}</td>
          <td>
            {{ props.item.paymentDate | date }}
          </td>
          <td>
            <v-btn :href="props.item.invoiceUrl" target="_blank" icon>
              <v-icon>link</v-icon>
            </v-btn>
          </td>
          <td>
            <v-btn :href="props.item.bankSlipUrl" target="_blank" icon
            :disabled="props.item.status == 'RECEIVED'">
              <v-icon>link</v-icon>
            </v-btn>
          </td>
        </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import store from '../store/index'
import {mapGetters} from 'vuex'

export default {
  data:()=>({
    pages:[5,10,25,50,100],
    pagination:{},
    items:[],
    total:0,
    headers: [
      { text: 'Status', value: 'status', sortable: false},
      { text: 'Descrição', value: 'description', sortable: false},
      { text: 'Emissão', value: 'dateCreated', sortable: false},
      { text: 'Valor', value: 'value', sortable: false},
      { text: 'Vencimento', value: 'dueDate', sortable: false},
      { text: 'Pagamento', value: 'paymentDate', sortable: false},
      { text: 'Fatura', value: 'invoiceUrl', sortable: false},
      { text: 'Boleto', value: 'bankSlipUrl', sortable: false},
    ]
  }),
  watch: {
    pagination: {
      async handler () {
        this.$store.state.loading = true
        let data = {
          id:this.$route.params.id,
          pagination:this.pagination
        }
        await store.dispatch('getPayments',data)
        this.items = this.payments.data
        this.total = this.payments.totalCount
        this.$store.state.loading = false
      },
      deep: true
    }
  },
  computed:{
    ...mapGetters([
      'loading',
      'payments'
    ])
  },
  async beforeRouteEnter(to, from, next) {
    document.title = "Cobranças"
    next()
  },
  filters: {
    date: (value)=>{
      if (!value) return ''
      value = new Date(value)
      value.setDate(value.getDate()+1)
      return value.toLocaleDateString("pt-BR")
    },
    money: (value)=>{
      if (!value) return '00,00'
      value = Number.parseFloat(value).toFixed(2).replace('.',',')
      return value
    }
  }
}
</script>

<style>

</style>